<template>
  <div id="sidebarda" 
    class="app-menu z-[100] flex-col bg-slate-900 dark:bg-slate-950 border-r border-slate-800 shadow-2xl transition-all duration-300 w-64 h-screen fixed md:sticky top-0"
    :class="[store.sidebar ? 'flex' : 'hidden md:flex']">
    <!-- Logo Section -->
    <NuxtLink href="/painel" class="flex items-center justify-center py-8 px-6 bg-slate-900/50 backdrop-blur-md border-b border-slate-800/50">
      <img src="assets/logo_white.png" class="h-8 w-auto hover:scale-105 transition-transform" alt="Ticket Smile Logo" />
    </NuxtLink>

    <!-- Navigation Scroll Area -->
    <div class="flex-1 overflow-y-auto px-4 py-6 scrollbar-hide space-y-8">
      
      <!-- Context Switcher (Voltar) -->
      <div v-if="!isMenu1Active" class="animate-fadeIn">
        <NuxtLink 
          :to="backLink" 
          class="flex items-center gap-3 px-4 py-3 rounded-xl bg-slate-800/40 text-slate-400 hover:text-white hover:bg-slate-800 transition-all border border-slate-700/30 group"
        >
          <i class="uil uil-arrow-left text-lg group-hover:-translate-x-1 transition-transform"></i>
          <span class="text-xs font-bold uppercase tracking-wider">{{ backText }}</span>
        </NuxtLink>
      </div>

      <!-- Main Menu Section -->
      <div>
        <p class="px-4 text-[10px] font-black text-slate-500 uppercase tracking-[0.2em] mb-4">Principal</p>
        <ul class="space-y-1.5">
          <li v-if="isMenu1Active">
            <NuxtLink to="/painel" @click="dropDownStep = 0" class="nav-item group" :class="{ active: activepage('/painel') }">
              <span class="nav-icon"><i class="uil uil-estate"></i></span>
              <span class="nav-text">Início</span>
              <span v-if="activepage('/painel')" class="nav-indicator"></span>
            </NuxtLink>
          </li>
          
          <li v-if="isMenu2Active && !isMenu3Active && !isMenu4Active && canAccess('organizador')">
            <NuxtLink :to="'/painel/org/' + $route.params.id" @click="dropDownStep = 0" class="nav-item group" :class="{ active: activepage('/painel/org/' + $route.params.id) }">
              <span class="nav-icon"><i class="uil uil-dashboard"></i></span>
              <span class="nav-text">Dashboard</span>
              <span v-if="activepage('/painel/org/' + $route.params.id)" class="nav-indicator"></span>
            </NuxtLink>
          </li>
        </ul>
      </div>

      <!-- Management Section -->
      <div v-if="isMenu2Active && !isMenu3Active && !isMenu4Active && !isMenu5Active && showOrgManagement">
        <p class="px-4 text-[10px] font-black text-slate-500 uppercase tracking-[0.2em] mb-4">Gestão</p>
        <ul class="space-y-2">
          <!-- Eventos Dropdown -->
          <li v-if="canAccess('eventos')">
            <button @click="toggleDrop(1)" class="nav-item w-full group" :class="{ active: dropDownStep == 1 || isRouteActive('eventos') }">
              <span class="nav-icon"><i class="uil uil-music"></i></span>
              <span class="nav-text">Eventos</span>
              <i class="uil uil-angle-right transition-transform duration-300" :class="{ 'rotate-90': dropDownStep == 1 }"></i>
            </button>
            <transition name="dropdown">
              <ul v-show="dropDownStep == 1" class="ml-10 mt-2 space-y-1 border-l border-slate-800">
                <li><NuxtLink :to="'/painel/org/' + $route.params.id + '/eventos'" class="sub-nav-item">Lista de Eventos</NuxtLink></li>
                <li v-if="canCreate('eventos')"><NuxtLink :to="'/painel/org/' + $route.params.id + '/eventos/add'" class="sub-nav-item text-pink-500 font-bold">+ Novo Evento</NuxtLink></li>
              </ul>
            </transition>
          </li>

          <!-- Locais Dropdown -->
          <li v-if="canAccess('locais')">
            <button @click="toggleDrop(2)" class="nav-item w-full group" :class="{ active: dropDownStep == 2 || isRouteActive('locais') }">
              <span class="nav-icon"><i class="uil uil-map-marker"></i></span>
              <span class="nav-text">Locais</span>
              <i class="uil uil-angle-right transition-transform duration-300" :class="{ 'rotate-90': dropDownStep == 2 }"></i>
            </button>
            <transition name="dropdown">
              <ul v-show="dropDownStep == 2" class="ml-10 mt-2 space-y-1 border-l border-slate-800">
                <li><NuxtLink :to="'/painel/org/' + $route.params.id + '/locais'" class="sub-nav-item">Todos os Locais</NuxtLink></li>
                <li v-if="canCreate('locais')"><NuxtLink :to="'/painel/org/' + $route.params.id + '/locais/add'" class="sub-nav-item text-pink-500 font-bold">+ Novo Local</NuxtLink></li>
              </ul>
            </transition>
          </li>

          <!-- Pedidos -->
          <li v-if="canAccess('pedidos')">
            <NuxtLink :to="'/painel/org/' + $route.params.id + '/pedidos'" @click="dropDownStep = 0" class="nav-item group" :class="{ active: activepage('pedidos') }">
              <span class="nav-icon"><i class="uil uil-receipt"></i></span>
              <span class="nav-text">Pedidos</span>
            </NuxtLink>
          </li>
          <!-- Comunicação -->
          <li v-if="canAccess('comunicacao')">
            <NuxtLink :to="'/painel/org/' + $route.params.id + '/comunicacao'" @click="dropDownStep = 0" class="nav-item group" :class="{ active: activepage('comunicacao') }">
              <span class="nav-icon"><i class="uil uil-envelope-alt"></i></span>
              <span class="nav-text">Comunicação</span>
            </NuxtLink>
          </li>

          <!-- Suporte ao Cliente -->
          <li v-if="canAccess('suporte')">
            <NuxtLink :to="'/painel/org/' + $route.params.id + '/suporte'" @click="dropDownStep = 0" class="nav-item group" :class="{ active: activepage('suporte') }">
              <span class="nav-icon"><i class="uil uil-comment-info"></i></span>
              <span class="nav-text">Suporte (Tickets)</span>
            </NuxtLink>
          </li>

          <!-- Financeiro Org Dropdown -->
          <li v-if="canAccess('financeiro')">
            <button @click="toggleDrop(20)" class="nav-item w-full group" :class="{ active: dropDownStep == 20 || isRouteActive('financeiro') }">
              <span class="nav-icon"><i class="uil uil-bill"></i></span>
              <span class="nav-text">Financeiro Org</span>
              <i class="uil uil-angle-right transition-transform duration-300" :class="{ 'rotate-90': dropDownStep == 20 }"></i>
            </button>
            <transition name="dropdown">
              <ul v-show="dropDownStep == 20" class="ml-10 mt-2 space-y-1 border-l border-slate-800">
                <li><NuxtLink :to="'/painel/org/' + $route.params.id + '/financeiro'" class="sub-nav-item">Dashboard</NuxtLink></li>
                <li><NuxtLink :to="'/painel/org/' + $route.params.id + '/financeiro/vendas'" class="sub-nav-item">Vendas</NuxtLink></li>
                <li><NuxtLink :to="'/painel/org/' + $route.params.id + '/financeiro/extrato'" class="sub-nav-item">Extrato</NuxtLink></li>
                <li><NuxtLink :to="'/painel/org/' + $route.params.id + '/financeiro/saques'" class="sub-nav-item">Saques</NuxtLink></li>
              </ul>
            </transition>
          </li>


          <!-- Bares Dropdown -->
          <li v-if="canAccess('bares')">
            <button @click="toggleDrop(30)" class="nav-item w-full group" :class="{ active: dropDownStep == 30 || isRouteActive('bar') }">
              <span class="nav-icon"><i class="uil uil-glass-martini-alt"></i></span>
              <span class="nav-text">Bares & PDVs</span>
              <i class="uil uil-angle-right transition-transform duration-300" :class="{ 'rotate-90': dropDownStep == 30 }"></i>
            </button>
            <transition name="dropdown">
              <ul v-show="dropDownStep == 30" class="ml-10 mt-2 space-y-1 border-l border-slate-800">
                <li><NuxtLink :to="'/painel/org/' + $route.params.id + '/bares'" class="sub-nav-item">Lista de Bares</NuxtLink></li>
                <li v-if="canCreate('bares')"><NuxtLink :to="'/painel/org/' + $route.params.id + '/bares/add'" class="sub-nav-item text-amber-500 font-bold">+ Novo Bar</NuxtLink></li>
              </ul>
            </transition>
          </li>

          <!-- Configurações Org -->
          <li v-if="canAccess('configs')">
            <NuxtLink :to="'/painel/org/' + $route.params.id + '/config'" @click="dropDownStep = 0" class="nav-item group" :class="{ active: activepage('config') }">
              <span class="nav-icon"><i class="uil uil-setting"></i></span>
              <span class="nav-text">Ajustes</span>
            </NuxtLink>
          </li>
        </ul>
      </div>

      <!-- Bar-specific Menu -->
      <div v-if="isMenu5Active && canAccess('bares')">
        <p class="px-4 text-[10px] font-black text-slate-500 uppercase tracking-[0.2em] mb-4">Gerenciar Bar</p>
        <ul class="space-y-2">
          <li>
            <NuxtLink :to="'/painel/org/' + $route.params.id + '/bar/' + $route.params.id_bar" @click="dropDownStep = 0" class="nav-item" :class="{ active: activepage('bar/' + $route.params.id_bar) && !$route.path.includes('/produtos') && !$route.path.includes('/estoque') && !$route.path.includes('/pedidos') && !$route.path.includes('/equipe') && !$route.path.includes('/nfc') && !$route.path.includes('/config') }">
              <span class="nav-icon"><i class="uil uil-chart-pie"></i></span>
              <span class="nav-text">Dashboard</span>
            </NuxtLink>
          </li>
          <li>
            <NuxtLink :to="'/painel/org/' + $route.params.id + '/bar/' + $route.params.id_bar + '/produtos'" class="nav-item" :class="{ active: $route.path.includes('/produtos') }">
              <span class="nav-icon"><i class="uil uil-tag-alt"></i></span>
              <span class="nav-text">Produtos & Cardápio</span>
            </NuxtLink>
          </li>
          <li>
            <NuxtLink :to="'/painel/org/' + $route.params.id + '/bar/' + $route.params.id_bar + '/estoque'" class="nav-item" :class="{ active: $route.path.includes('/estoque') }">
              <span class="nav-icon"><i class="uil uil-box"></i></span>
              <span class="nav-text">Estoque</span>
            </NuxtLink>
          </li>
          <li>
            <NuxtLink :to="'/painel/org/' + $route.params.id + '/bar/' + $route.params.id_bar + '/pedidos'" class="nav-item" :class="{ active: $route.path.includes('/pedidos') }">
              <span class="nav-icon"><i class="uil uil-receipt"></i></span>
              <span class="nav-text">Pedidos</span>
            </NuxtLink>
          </li>
          <li>
            <NuxtLink :to="'/painel/org/' + $route.params.id + '/bar/' + $route.params.id_bar + '/equipe'" class="nav-item" :class="{ active: $route.path.includes('/equipe') }">
              <span class="nav-icon"><i class="uil uil-users-alt"></i></span>
              <span class="nav-text">Equipe & Balcões</span>
            </NuxtLink>
          </li>
          <li>
            <NuxtLink :to="'/painel/org/' + $route.params.id + '/bar/' + $route.params.id_bar + '/nfc'" class="nav-item" :class="{ active: $route.path.includes('/nfc') }">
              <span class="nav-icon"><i class="uil uil-wifi"></i></span>
              <span class="nav-text">Cartões NFC</span>
            </NuxtLink>
          </li>
          <li>
            <NuxtLink :to="'/painel/org/' + $route.params.id + '/bar/' + $route.params.id_bar + '/config'" class="nav-item" :class="{ active: $route.path.includes('/config') }">
              <span class="nav-icon"><i class="uil uil-setting"></i></span>
              <span class="nav-text">Configurações</span>
            </NuxtLink>
          </li>
        </ul>
      </div>

      <!-- Specific Event Menu -->
      <div v-if="isMenu3Active && canAccess('eventos')">
        <p class="px-4 text-[10px] font-black text-slate-500 uppercase tracking-[0.2em] mb-4">Gerenciar Evento</p>
        <ul class="space-y-2">
          <li>
            <NuxtLink :to="'/painel/org/' + $route.params.id + '/evento/' + $route.params.id_evento" @click="dropDownStep = 0" class="nav-item" :class="{ active: activepage('evento/' + $route.params.id_evento) }">
              <span class="nav-icon"><i class="uil uil-chart-pie"></i></span>
              <span class="nav-text">Resumo</span>
            </NuxtLink>
          </li>
          
          <li>
            <button @click="toggleDrop(3)" class="nav-item w-full" :class="{ active: dropDownStep == 3 }">
              <span class="nav-icon"><i class="uil uil-ticket"></i></span>
              <span class="nav-text">Ingressos</span>
              <span class="uil uil-angle-right" :class="{ 'rotate-90': dropDownStep == 3 }"></span>
            </button>
            <ul v-show="dropDownStep == 3" class="ml-10 mt-2 space-y-1 border-l border-slate-800">
              <li><NuxtLink :to="'/painel/org/' + $route.params.id + '/evento/' + $route.params.id_evento + '/ingressos'" class="sub-nav-item">Tipos</NuxtLink></li>
              <li><NuxtLink :to="'/painel/org/' + $route.params.id + '/evento/' + $route.params.id_evento + '/ingressos/add'" class="sub-nav-item font-bold text-pink-500">+ Adicionar</NuxtLink></li>
            </ul>
          </li>

          <li>
            <NuxtLink :to="'/painel/org/' + $route.params.id + '/evento/' + $route.params.id_evento + '/participantes'" class="nav-item" :class="{ active: activepage('participantes') }">
              <span class="nav-icon"><i class="uil uil-users-alt"></i></span>
              <span class="nav-text">Participantes</span>
            </NuxtLink>
          </li>

          <li>
            <NuxtLink :to="'/painel/org/' + $route.params.id + '/evento/' + $route.params.id_evento + '/financeiro'" class="nav-item" :class="{ active: activepage('financeiro') }">
              <span class="nav-icon"><i class="uil uil-money-withdraw"></i></span>
              <span class="nav-text">Financeiro</span>
            </NuxtLink>
          </li>

          <li>
            <NuxtLink :to="'/painel/org/' + $route.params.id + '/evento/' + $route.params.id_evento + '/config'" class="nav-item" :class="{ active: $route.path.includes('config') }">
              <span class="nav-icon"><i class="uil uil-setting"></i></span>
              <span class="nav-text">Ajustes</span>
            </NuxtLink>
          </li>
        </ul>
      </div>

    </div>

    <!-- User Profile / Footer Section -->
    <div class="p-4 border-t border-slate-800 bg-slate-900/80 backdrop-blur-xl">
      <div class="flex items-center gap-3 p-3 rounded-2xl bg-white/5 border border-white/5">
        <div class="w-10 h-10 rounded-xl bg-pink-600 flex items-center justify-center text-white font-black shadow-lg shadow-pink-600/20">
          U
        </div>
        <div class="flex-1 min-w-0">
          <p class="text-sm font-bold text-white truncate">Organizador</p>
          <p class="text-[10px] font-bold text-slate-500 uppercase tracking-tighter">Premium Plan</p>
        </div>
        <NuxtLink to="/auth/sair" class="p-2 text-slate-400 hover:text-red-400 transition-colors">
          <i class="uil uil-sign-out-alt text-xl"></i>
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import { useAppStore } from '@/stores/index';
const store = useAppStore();
const dropDownStep = ref(0);
const route = useRoute();
const runtimeConfig = useRuntimeConfig();
const token = useCookie('token');
const apidomain = runtimeConfig.public.NUXT_API_BACK_URL;

const hasOrganizationContext = computed(() => Boolean(route.params.id));
const { data: orgAccess, refresh: refreshOrgAccess } = useAsyncData(
  'painel-org-access',
  async () => {
    if (!route.params.id || !token.value) return { permissions: {} };
    try {
      return await $fetch(`${apidomain}/organizador/${route.params.id}/access`, {
        headers: { authorization: `Bearer ${token.value}` }
      });
    } catch {
      return { id: route.params.id, permissions: {} };
    }
  },
  {
    server: false,
    immediate: false,
    default: () => ({ id: null, permissions: {} })
  }
);

const accessLoadedForCurrentOrganization = computed(() => {
  if (!hasOrganizationContext.value) return true;
  return String(orgAccess.value?.id || '') === String(route.params.id || '');
});

const permissions = computed(() => {
  if (!accessLoadedForCurrentOrganization.value) return {};
  return orgAccess.value?.permissions || {};
});

function canAccess(key) {
  if (!hasOrganizationContext.value) return true;
  if (!accessLoadedForCurrentOrganization.value) return false;
  return permissions.value[key]?.status === true;
}

function canCreate(key) {
  if (!hasOrganizationContext.value) return true;
  if (!accessLoadedForCurrentOrganization.value) return false;
  return permissions.value[key]?.canCreate === true || permissions.value[key]?.permissao >= 3;
}

const showOrgManagement = computed(() => {
  return ['eventos', 'locais', 'pedidos', 'comunicacao', 'suporte', 'financeiro', 'configs', 'bares']
    .some((key) => canAccess(key));
});

// Menu State Logic
const isMenu1Active = computed(() => route.path === '/painel' || route.path === '/painel/org/add');
const isMenu2Active = computed(() => route.params.id && !route.params.id_evento && !route.params.id_comercio && !route.params.id_bar);
const isMenu3Active = computed(() => route.params.id_evento);
const isMenu4Active = computed(() => route.params.id_comercio);
const isMenu5Active = computed(() => route.params.id_bar);

const backLink = computed(() => {
  if (isMenu3Active.value) return `/painel/org/${route.params.id}/eventos`;
  if (isMenu4Active.value) return `/painel/org/${route.params.id}/comercios`;
  if (isMenu5Active.value) return `/painel/org/${route.params.id}/bares`;
  return '/painel';
});

const backText = computed(() => {
  if (isMenu3Active.value) return 'Voltar p/ Eventos';
  if (isMenu4Active.value) return 'Voltar p/ Comércios';
  if (isMenu5Active.value) return 'Voltar p/ Bares';
  return 'Voltar';
});

onMounted(() => {
  if (route.params.id && token.value) refreshOrgAccess();
  if (route.path.includes('eventos')) dropDownStep.value = 1;
  else if (route.path.includes('locais')) dropDownStep.value = 2;
  else if (route.params.id_evento) dropDownStep.value = 3;
  else if (route.path.includes('financeiro')) dropDownStep.value = 20;
  else if (route.path.includes('bares') || route.params.id_bar) dropDownStep.value = 30;
});

watch(() => [route.params.id, token.value], () => {
  if (route.params.id && token.value) refreshOrgAccess();
});

function toggleDrop(key) {
  dropDownStep.value = dropDownStep.value === key ? 0 : key;
}

function activepage(path) {
  const currentPath = route.path;
  
  // Dashboard principal e Dashboard da Org: Exact Match
  if (path === '/painel' || path === ('/painel/org/' + route.params.id)) {
    return currentPath === path;
  }

  // Resumo do Evento: Exact Match para evitar que sub-páginas ativem o 'Resumo'
  if (path === 'evento/' + route.params.id_evento) {
    const eventSummaryPath = `/painel/org/${route.params.id}/evento/${route.params.id_evento}`;
    return currentPath === eventSummaryPath;
  }

  // Outras páginas: use includes
  return currentPath.includes(path);
}

function isRouteActive(keyword) {
  return route.path.includes(keyword);
}
</script>

<style lang="css" scoped>
#sidebarda {
  z-index: 9999!important;
}

.nav-item {
  @apply flex items-center gap-3 px-4 py-3 rounded-2xl text-slate-400 font-bold transition-all duration-300 relative overflow-hidden;
}

.nav-item:hover {
  @apply bg-white/5 text-white;
}

.nav-item.active {
  @apply bg-pink-600/10 text-pink-500;
}

.nav-icon {
  @apply w-6 flex items-center justify-center text-xl transition-transform duration-300;
}

.nav-item:hover .nav-icon {
  @apply scale-110;
}

.nav-text {
  @apply text-sm flex-1 truncate text-left;
}

.nav-indicator {
  @apply absolute left-0 top-1/2 -translate-y-1/2 w-1 h-6 bg-pink-600 rounded-r-full shadow-[0_0_15px_rgba(236,72,153,0.5)];
}

.sub-nav-item {
  @apply flex items-center gap-3 py-2.5 px-4 text-xs text-slate-500 hover:text-white transition-colors relative;
}

.sub-nav-item::before {
  content: '';
  @apply w-1.5 h-1.5 bg-slate-800 rounded-full transition-colors flex-shrink-0;
}

.sub-nav-item:hover::before {
  @apply bg-pink-600;
}

.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

.dropdown-enter-active, .dropdown-leave-active {
  transition: all 0.3s ease;
  max-height: 200px;
}

.dropdown-enter-from, .dropdown-leave-to {
  opacity: 0;
  max-height: 0;
  transform: translateY(-10px);
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(5px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-fadeIn {
  animation: fadeIn 0.4s ease-out forwards;
}
</style>
